"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRO02_DEFAULT_ERROR = void 0;
exports.PRO02_DEFAULT_ERROR = {
    title: 'Produit indisponible',
    text: 'Ce produit ne peut pas être ajouté à votre commande car il est victime de son succès et n’est plus disponible.',
    handle: function (resp) {
        var _a, _b, _c;
        var error = (_c = (_b = (_a = resp.data) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b.globals) === null || _c === void 0 ? void 0 : _c[0];
        var products = (error === null || error === void 0 ? void 0 : error.products) || [__assign({}, (error === null || error === void 0 ? void 0 : error.metadata) || {})];
        if (!products || products.length === 0) {
            return {
                title: 'Produit indisponible',
                text: 'Ce produit ne peut pas être ajouté à votre commande car il est victime de son succès et n’est plus disponible.',
            };
        }
        var productsName = products.map(function (product) { return "\"".concat(product.boxName || product.name, "\""); }).join(', ');
        if (products.length === 1) {
            return {
                title: 'Produit indisponible',
                text: "Le produit <b>".concat(productsName, "</b> vient d'\u00EAtre vendu et n\u2019est d\u00E9sormais plus disponible."),
            };
        }
        else if (products.length > 1) {
            return {
                title: 'Produits indisponibles',
                text: "Les produits <b>".concat(productsName, "</b> viennent d'\u00EAtre vendus et ne sont d\u00E9sormais plus disponibles."),
            };
        }
        else {
            return {
                title: 'Produit indisponible',
                text: 'Ce produit ne peut pas être ajouté à votre commande car il est victime de son succès et n’est plus disponible.',
            };
        }
    }
};
exports.default = {
    default: exports.PRO02_DEFAULT_ERROR,
};
//# sourceMappingURL=PRO002Handler.js.map